module.exports = __webpack_public_path__ + "static/media/logo_dark.0746509c.png";